import { React, useState, useEffect } from 'react'
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleChevronDown,
  faLock,
  faMagnifyingGlass,
  faPenToSquare,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Transactionhistory from './Apexchart/Transactionhistory';
import { SERVER_URL } from '../../../Config';
import axios from 'axios';

export default function Transactions() {
  const [currentPage, setCurrentPage] = useState(1);
  const [entitiesPerPage, setEntitiesPerPage] = useState(7);
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [transactions, setTransactions] = useState([]);


  const adminData = JSON.parse(sessionStorage.getItem('admin'));
  const email = adminData?.email || '';

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/totalTransaction`);
        if (res.data.status) {
          setTransactions(res.data.transactions);
        } else {
          console.error("Error fetching transactions:", res.data.message);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    fetchTransactions();
    fetchUserData();
  }, []);


  const filteredEntries = transactions.filter(
    (entry) =>
      entry.trn_hash.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      entry.created_at.includes(searchTerm)
  );

  const totalPages = Math.ceil(filteredEntries.length / entitiesPerPage);
  const indexOfLastEntity = currentPage * entitiesPerPage;
  const indexOfFirstEntity = indexOfLastEntity - entitiesPerPage;

  const currentEntities = filteredEntries.slice(
    indexOfFirstEntity,
    indexOfLastEntity
  );

  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleDropdownChange = (e) => {
    setEntitiesPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const generatePageNumbers = () => {
    const maxPagesToShow = 5;
    const pages = [];
    const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const [userData, setUserData] = useState([]);
  const [labels, setLabels] = useState([]);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/usersTenMonthCount`);
      const dataPoints = response.data.map(item => item.count);
      const labelPoints = response.data.map(item => item.month);
      setUserData(dataPoints);
      setLabels(labelPoints);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  return (
    <div className='bg-[#111111] py-5'>
      <div className='flex flex-col lg:flex-row gap-5 justify-between px-5'>
        <div className='lg:w-[35%]'>
          <div>
            <p className='font-inter text-[#878787]'>Total Withdraw</p>
          </div>
          <div className='bg-[#1e1e1e] px-4 py-2 rounded-md'>
            <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
              <p className='font-inter text-white font-bold text-lg flex gap-2 '>$0&nbsp;<img className='w-2/12' src='/assets/other/Frame 40640.svg'></img></p>
              <p className='text-[#A7A8AB] font-inter'>May, 2023</p>
            </div>
            <div className='flex flex-col lg:flex-row justify-between mt-3'>
              <div className='lg:w-[50%]'>
                <p className='text-[#878787] font-inter flex items-center text-xs 2xl:text-sm'><img src='/assets/other/Award.svg'></img>&nbsp;Target Achieved</p>
                <p className='text-[#A7A8AB] font-bold text-lg px-5'>$0</p>
                <p className='text-[#878787] font-inter flex items-center text-xs 2xl:text-sm text-nowrap'><img src='/assets/other/octicon_goal-16.svg'></img>&nbsp;This month Target</p>
                <p className='text-[#A7A8AB] font-bold text-lg px-5'>$0</p>
              </div>
              <div className='lg:w-[50%]'>
                <p className='text-center text-[#A7A8AB] text-xs 2xl:text-sm'>Target vs Achievement</p>
                <div className='flex justify-center'> <img className='w-6/12' src='/assets/other/file (40) 1.svg'></img></div>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:w-[65%]'>
          <div>
            <Transactionhistory data={userData} labels={labels}/>
          </div>
        </div>
      </div>
      <div>
        <div className="flex justify-between items-center mt-5 px-5">
          <div
            className={`bg-[#D9D9D9]/10 border rounded-full flex items-center`}
          >
            <input
              className="bg-transparent rounded-md py-1 px-3 outline-none w-[100%]"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <FontAwesomeIcon icon={faMagnifyingGlass} className="px-3" />
          </div>
          <p className="text-end text-xs px-3 text-white">
            Show no of entity
            <select
              className="ml-2 outline-none rounded-md bg-transparent border-[1px]"
              onChange={handleDropdownChange}
              value={entitiesPerPage}
            >
              <option className="text-black" value="7">
                7
              </option>
              <option className="text-black" value="10">
                10
              </option>
            </select>
          </p>
        </div>
        <div className=" w-full overflow-hidden overflow-x-auto px-5 py-5">
          <table className=" w-full overflow-hidden overflow-x-auto text-sm 2xl:text-base  rounded-t-xl">
            <thead
              className={` bg-[#1d1d1c] 2xl:text-lg `}
            >
              <tr>
                <th className="py-5 px-5 md:px-10 font-Montserrat text-white whitespace-nowrap text-center ">
                  Transaction Hash
                </th>
                <th className="py-5 px-5 md:px-2 font-Montserrat text-white whitespace-nowrap text-center ">
                  Tokens
                </th>
                <th className="py-5 px-5 md:px-2 font-Montserrat text-white whitespace-nowrap text-center">
                  Date of Transaction
                </th>
                <th className="py-5 px-5 md:px-2 font-Montserrat text-white whitespace-nowrap text-center">
                  Transaction Type
                </th>

              </tr>
            </thead>
            <tbody className="w-full text-sm rounded-lg px-3">
              {currentEntities.length === 0 ? (
                <tr>
                  <td colSpan="4" className="p-3 text-center text-white">
                    No transactions found
                  </td>
                </tr>
              ) : (
                currentEntities.map((transaction, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? "bg-[#23221f]" : "bg-[#1d1d1c]"}`}
                  >
                    <td className="p-3 text-center text-white">{transaction.trn_hash}</td>
                    <td className="p-3 text-center text-green-400">{transaction.amount}</td>
                    <td className="p-3 text-center text-white">{transaction.created_at}</td>
                    <td className="p-3 text-center text-white">Debit / Credit</td>
                  </tr>
                )))}
            </tbody>
          </table>
        </div>
        <div className="mb-3 flex justify-end gap-1 text-xs px-10 mt-5">
          <button
            className={`px-2 py-1 rounded-lg ${currentPage === 1
              ? "bg-white/10 cursor-not-allowed"
              : ""
              }`}
            onClick={handlePrevClick}
            disabled={currentPage === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <div className="flex gap-1">
            {generatePageNumbers().map((page) => (
              <button
                key={page}
                className={`px-3 py-1 rounded-lg ${page === currentPage
                  ? "bg-white/30 text-white"
                  : "bg-white/10"
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}
          </div>
          <button
            className={`px-2 py-1 rounded-lg ${currentPage === totalPages
              ? "bg-white/10 cursor-not-allowed"
              : ""
              }`}
            onClick={handleNextClick}
            disabled={currentPage === totalPages}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </div>
  )
}
